import React from 'react';
import './FrequentlyTraded.css'
import { useTranslation } from "react-i18next";
import * as Colors from '../../../../constants/Colors';
import FlagIconEmirates from "../../../../assets/images/flag_emirates2.jpg";
import HeaderTitle from '../../CopyPeopleList/HeaderTitle'


const FrequentlyTraded = () => {
    const { i18n } = useTranslation();
    let dir = "ltr";
    if (i18n.language === "ar") {

        dir = "rtl";
    }
    return (
        <div>
            <HeaderTitle title="Frequently Traded" dir={dir} />

            <ul className='list-FrequentlyTraded-container'>
                <li className='item-FrequentlyTraded'>
                    <a className="FrequentlyTraded-part-1" href="" >
                        <span className="image-container image-overlay" style={{ backgroundColor: "rgb(115, 191, 255)" }}>
                            <img src={FlagIconEmirates} width={"100%"} height={"100%"} alt="logo" />
                        </span>
                        <span className="info">
                            <span className="name-main ets-bold ng-star-inserted" > ADX </span>
                            <span className="name-sub ng-star-inserted" > Abu Dhabi Securities Exchange </span>
                        </span>
                    </a>
                    <span className="FrequentlyTraded-part-2">
                        <span className="name-main ets-bold ng-star-inserted" >45 Trades  </span>
                        <span className="name-sub ng-star-inserted" > 43.25% </span>
                    </span>
                    <span className="FrequentlyTraded-part-3">
                        <span className="name-main ets-bold ng-star-inserted" > Profitable </span>
                        <span className="name-sub ng-star-inserted" > 57.23% </span>
                    </span>
                    <span className="FrequentlyTraded-part-4">
                        <span className="name-main ets-bold ng-star-inserted" ><div className="increase-image img-15" /> 2.21% Average Loss </span>
                        <span className="name-sub ng-star-inserted" > <div className="decrease-image img-15" /> 6.32% Average Loss </span>
                    </span>
                </li>
                <li className='item-FrequentlyTraded'>
                    <a className="FrequentlyTraded-part-1" href="" >
                        <span className="image-container image-overlay" style={{ backgroundColor: "rgb(115, 191, 255)" }}>
                            <img src={FlagIconEmirates} width={"100%"} height={"100%"} alt="logo" />
                        </span>
                        <span className="info">
                            <span className="name-main ets-bold ng-star-inserted" >DFM </span>
                            <span className="name-sub ng-star-inserted" > Dubai Financial Market </span>
                        </span>
                    </a>
                    <span className="FrequentlyTraded-part-2">
                        <span className="name-main ets-bold ng-star-inserted" >45 Trades  </span>
                        <span className="name-sub ng-star-inserted" > 65.36% </span>
                    </span>
                    <span className="FrequentlyTraded-part-3">
                        <span className="name-main ets-bold ng-star-inserted" > Profitable </span>
                        <span className="name-sub ng-star-inserted" > 32.8% </span>
                    </span>
                    <span className="FrequentlyTraded-part-4">
                        <span className="name-main ets-bold ng-star-inserted" ><div className="increase-image img-15" /> 1.21% Average Loss </span>
                        <span className="name-sub ng-star-inserted" > <div className="decrease-image img-15" /> 8.9% Average Loss </span>
                    </span>
                </li>
            </ul>
        </div>
    );
};

export default FrequentlyTraded;


